export default __webpack_public_path__ + "static/media/carbon-neutral.d67a48c9.svg";